module.exports = __webpack_public_path__ + "49ca6a97e7a12c8128a6cc27202d693c.jpg";